import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'cookie_consent';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const rejectAll = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white shadow-2xl">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-300 max-w-2xl">
              Utilizamos cookies para melhorar sua experiência, analisar o tráfego do site e exibir
              anúncios personalizados por meio de parceiros de publicidade. Ao clicar em "Aceitar Todos",
              você concorda com o uso de cookies conforme descrito em nossa{' '}
              <Link to="/politica-de-privacidade" className="text-blue-400 hover:underline">
                Política de Privacidade
              </Link>
              .
            </p>
            {showDetails && (
              <div className="mt-3 text-xs text-gray-400 space-y-1">
                <p>• <strong className="text-gray-300">Cookies essenciais:</strong> Necessários para o funcionamento do site (sempre ativos).</p>
                <p>• <strong className="text-gray-300">Cookies analíticos:</strong> Google Analytics — nos ajudam a entender como você usa o site.</p>
                <p>• <strong className="text-gray-300">Cookies de publicidade:</strong> Parceiros de publicidade — exibem anúncios relevantes para você.</p>
              </div>
            )}
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="mt-2 text-xs text-gray-500 hover:text-gray-300 underline transition"
            >
              {showDetails ? 'Ocultar detalhes' : 'Ver detalhes dos cookies'}
            </button>
          </div>
          <div className="flex gap-3 shrink-0">
            <button
              onClick={rejectAll}
              className="px-4 py-2 text-sm border border-gray-500 text-gray-300 rounded-lg hover:bg-gray-800 transition"
            >
              Rejeitar Todos
            </button>
            <button
              onClick={acceptAll}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold"
            >
              Aceitar Todos
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
